import {
  Button,
  Dialog as MuiDialog,
  DialogActions,
  DialogContentText,
  DialogTitle,
} from '@mui/material'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles({
  topScrollPaper: {
    alignItems: 'flex-start',
  },
  topPaperScrollBody: {
    verticalAlign: 'top',
  },
  paper: {
    padding: 20,
  },
})

interface Props {
  onSubmit?: () => void
  [key: string]: any
}

export const Dialog = ({
  isOpen = true,
  title,
  text,
  children,
  hasSubmitButton = true,
  submitText = '',
  isSubmitDisabled = false,
  onSubmit,
  closeText = 'Cancel',
  onClose,
}: Props) => {
  const classes = useStyles()

  return (
    <MuiDialog
      open={isOpen}
      onClose={onClose}
      classes={{
        scrollPaper: classes.topScrollPaper,
        paperScrollBody: classes.topPaperScrollBody,
        paper: classes.paper,
      }}
    >
      <DialogTitle style={{ textAlign: 'center', padding: 0 }}>
        {title}
      </DialogTitle>
      <DialogContentText>{text}</DialogContentText>
      {children}
      <DialogActions>
        {hasSubmitButton && (
          <Button
            variant="contained"
            disabled={isSubmitDisabled}
            onClick={onSubmit}
          >
            {submitText}
          </Button>
        )}
        <Button onClick={onClose}>{closeText}</Button>
      </DialogActions>
    </MuiDialog>
  )
}
